import Shape from '../models/Shape';

export default function (p, code, scale, width, height) {
    let angle = 360;
    let rotationSpeed = 0.15;
    const reflectionCount = 2;
    let shape = null;
    let renderScale = scale;
    let isFirstFrame = true;
    let firstFrameCallback = null;

    p.setup = function () {
        p.createCanvas(width, height, p.WEBGL);
        p.angleMode(p.DEGREES);
        p.noStroke();

        const color = p.color(p.random(100, 255), p.random(100, 255), p.random(100, 255), 200);
        shape = new Shape(0, 0, 40, color, p, code);
    };

    p.draw = function () {
        p.background(10, 10, 30);

        p.rotate(p.frameCount * rotationSpeed);

        p.push();
        p.rotate(angle);

        for (let r = 0; r < reflectionCount; r++) {
            p.push();

            const alpha = 1.0 / (r + 1.5);

            p.drawingContext.globalAlpha = alpha;
            p.scale(renderScale);
            shape.display(0);

            p.pop();
        }

        p.pop();

        p.drawingContext.globalAlpha = 1.0;

        if (isFirstFrame) {
            if (firstFrameCallback) {
                firstFrameCallback();
            }
            isFirstFrame = false;
        }
    };

    p.updateCode = function (newCode) {
        shape.updateCode(newCode);
    };

    p.updateScale = function (newScale) {
        shape.updateScale(newScale);
    };

    p.setFirstFrameCallback = (callback) => {
        firstFrameCallback = callback;
    };
}
